import { defineMessages } from 'react-intl';

export default defineMessages({
  saveAvailability: {
    id: 'app.components.AvailabilityForm.saveAvailability',
    defaultMessage: 'Save availability',
  },
  weekday: {
    id: 'app.components.AvailabilityForm.weekday',
    defaultMessage: 'Weekday',
  },
  timeFrame: {
    id: 'app.components.AvailabilityForm.timeFrame',
    defaultMessage: 'Time frame',
  },
  startingDate: {
    id: 'app.components.AvailabilityForm.startingDate',
    defaultMessage: 'Valid from',
  },
  start: {
    id: 'app.components.AvailabilityForm.start',
    defaultMessage: 'From',
  },
  end: {
    id: 'app.components.AvailabilityForm.end',
    defaultMessage: 'To',
  },
  frequency: {
    id: 'app.components.AvailabilityForm.frequency',
    defaultMessage: 'Frequency',
  },
  weekly: {
    id: 'app.components.AvailabilityForm.weekly',
    defaultMessage: 'Weekly',
  },
  monthly: {
    id: 'app.components.AvailabilityForm.monthly',
    defaultMessage: 'Monthly',
  },
  weeklyInterval: {
    id: 'app.components.AvailabilityForm.weeklyInterval',
    defaultMessage:
      '{nthWeek, select, 1 {Every} other {Every}} <nth></nth> {nthWeek, select, 1 {week} other {weeks}}',
  },
  monthlyInterval: {
    id: 'app.components.AvailabilityForm.monthlyInterval',
    defaultMessage: 'Every <nth></nth> {weekday}',
  },
  first: {
    id: 'app.components.AvailabilityForm.first',
    defaultMessage: 'first',
  },
  second: {
    id: 'app.components.AvailabilityForm.second',
    defaultMessage: 'second',
  },
  third: {
    id: 'app.components.AvailabilityForm.third',
    defaultMessage: 'third',
  },
  fourth: {
    id: 'app.components.AvailabilityForm.fourth',
    defaultMessage: 'fourth',
  },
  fifth: {
    id: 'app.components.AvailabilityForm.fifth',
    defaultMessage: 'fifth',
  },
  every: {
    id: 'app.components.AvailabilityForm.every',
    defaultMessage: 'every',
  },
  hasVehicle: {
    id: 'app.components.AvailabilityForm.hasVehicle',
    defaultMessage: 'I have a car available for this shift',
  },
  endTimeMustBeBeforeStartTime: {
    id: 'app.components.AvailabilityForm.endTimeMustBeBeforeStartTime',
    defaultMessage: 'Time frame invalid',
  },
  weeklyIntervalMustBeAtLeastOne: {
    id: 'app.components.AvailabilityForm.weeklyIntervalMustBeAtLeastOne',
    defaultMessage: 'Must be at least 1',
  },
  weeklyIntervalMustBeLessThanTen: {
    id: 'app.components.AvailabilityForm.weeklyIntervalMustBeLessThanTen',
    defaultMessage: 'Must be less than 10',
  },
});
